import { useLayoutEffect } from 'react';

export default function useScrollTop() {
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
        // document.body.scrollTo(0, 0);
    }, []);
}
